import { render, staticRenderFns } from "./PhraseSearchComponent.vue?vue&type=template&id=bb3f532c&scoped=true"
import script from "./PhraseSearchComponent.vue?vue&type=script&lang=js"
export * from "./PhraseSearchComponent.vue?vue&type=script&lang=js"
import style0 from "./PhraseSearchComponent.vue?vue&type=style&index=0&id=bb3f532c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3f532c",
  null
  
)

export default component.exports